import { render, staticRenderFns } from "./ScoutingTasksWidget.vue?vue&type=template&id=20f039fb&scoped=true"
import script from "./ScoutingTasksWidget.vue?vue&type=script&lang=js"
export * from "./ScoutingTasksWidget.vue?vue&type=script&lang=js"
import "./ScoutingTasksWidget.vue?vue&type=style&index=0&id=20f039fb&prod&scoped=true&lang=css"
/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f039fb",
  null
  
)

export default component.exports